import React from 'react';
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

const GICSSelect = ({input, label, options, optionsSelect, parent, meta: {touched, error, warning}}) => {
    return (
        <div>
            <MuiThemeProvider>
            <SelectField
                floatingLabelText={label}
                errorText={touched && error}
                {...input}
                onChange={(event, index, value) => input.onChange(value)}
                children={renderGICSSelectOptions(options, optionsSelect, parent)}
                fullWidth={true}
                />
            </MuiThemeProvider>
        </div>
    );
}

export default GICSSelect;

const renderGICSSelectOptions = (options, optionsSelect, parent) => {
    var returnjsx = [];
    var field;
    var lastext;
    for (var i = 0; i < options.length; i++) {
        field = options[i];
        if (checkGICSFilters(field,optionsSelect,parent)) {
            if (i > 0 && field[optionsSelect] !== lastext){
                lastext = field[optionsSelect];
                returnjsx.push (
                    <MenuItem key={field[optionsSelect]} value={field[optionsSelect]} primaryText={field[optionsSelect]} />
                );
            }
        }
    }

    return returnjsx;
}

const checkGICSFilters = (field,optionsSelect,parent) => {
    // Use this to refine the list of options shown for GICS
    var returnvalue = false
    // console.log(field);
    // console.log(parent);
    switch (optionsSelect) {
        case 'sector':
            returnvalue = true;
            break;
        case 'group':
            returnvalue = true;
            break;
        case 'industrygroup':
            if (field.sector === parent) {
                returnvalue = true;
            }
            break;
        case 'industry':
            if (field.industrygroup === parent) {
                returnvalue = true;
            }
            break;
        case 'subindustry':
            if (field.industry === parent) {
                returnvalue = true;
            }
            break;
        case 'subgroup':
            if (field.group === parent) {
                returnvalue = true;
            }
            break;
        default:
            break;
    }

    return returnvalue;
}



// WEBPACK FOOTER //
// ./src/components/gicsselect.js